/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from "../views/index/IndexPage.vue"
import VerifyEmail from "../views/index/VerifyEmail.vue"
import CreatePassword from "../views/index/createPassword.vue"
import SignupPage from "../views/signup/SignupPage.vue"
import SignupPage2 from "../views/signup/SignupPage2.vue"
import DashboardPage from "../views/dashboard/DashboardPage.vue"
import AdminPage from "../views/dashboard/AdminPage.vue"
import MainPage from "../views/dashboard/MainPage.vue"
import Models from "../views/dashboard/MainPage.vue"
import UserChat from "../views/dashboard/UserChat.vue"
import UserChatHangout from "../views/dashboard/UserChatHangout.vue"
import ProfilePage from "../views/ProfilePage.vue"
import GuestSignupPage from '@/views/signup/GuestSignupPage.vue'
import LoginPage from '@/views/signup/LoginPage.vue'
import EscortDetailPage from '@/views/EscortDetailPage.vue'
import CreateAccountLayout from '@/views/dashboard/CreateAccountLayout.vue'
import EditProfilePage from '@/views/EditProfilePage.vue'
import TourDetailPage from '@/views/TourDetailPage.vue'
import VideoDetailsPage from '@/views/VideoDetailsPage.vue'
import BoostPlansPage from '@/views/BoostPlansPage.vue'
import RoomsLayout from '@/views/dashboard/RoomsLayout.vue'
import RoomsPage from '@/views/dashboard/RoomsPage.vue'
import ClientPage from '@/views/ClientPage.vue'
import ActivatePlan from '@/views/ActivatePlan.vue'
import FaqPage from '@/views/dashboard/FaqPage.vue'
import BankPage from '@/views/BankPage.vue'
import AddBank from '@/views/AddBank.vue'
import WalletPage from '@/views/WalletPage.vue'
import VideoPage from '@/views/VideoPage.vue'
import LoungePage from '@/views/dashboard/LoungePage.vue'
import GroupChat from '@/views/dashboard/GroupChat.vue'
import WalletTopupPage from '@/views/WalletTopupPage.vue'

import store from "@/store";

Vue.use(VueRouter);
// parse jwt token
function parseJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}


function beforeRouteEnter(to, from, next) {
  try {
    const token = localStorage.getItem("wertyuiojhdfghhdrtfyguh");
    const balance = Number(localStorage.getItem("user_balance") || 0);
    const role = localStorage.getItem("role");

    // No token → redirect to login
    if (!token) {
      return next("/login");
    }

    const jwtPayload = parseJwt(token);

    // Token expired
    if (!jwtPayload || jwtPayload.exp < Date.now() / 1000) {
      localStorage.removeItem("wertyuiojhdfghhdrtfyguh");
      localStorage.removeItem("user_balance");
      return next("/");
    }


  /**
   * VIP Lounge protection
   * Route meta: meta: { requiresVip: true }
   */
  if (role == 'escort' || role == 'content-creator') {
    return next();
  }
  
  if (to.meta?.requiresVip && balance < 3000) {
    return next({
      path: "/wallet-topup",
      query: {
        vipBlocked: 1
      }
    });
  }

    // Authenticated
    next();
  } catch (err) {
    console.error("Auth guard error:", err);
    localStorage.removeItem("wertyuiojhdfghhdrtfyguh");
    localStorage.removeItem("user_balance");
    next("/");
  }
}
  
const routes = [
  
  {
    path: '/verify-email/:id',
    name: 'VerifyEmail',
    component: VerifyEmail,
  },
  {
    path: '/reset-password/:id',
    name: 'CreatePassword',
    component: CreatePassword,
  },
  {
    path: '/signup',
    name: 'SignupPage',
    component: SignupPage
  },

  {
    path: '/register',
    name: 'CreateAccountLayout',
    component: CreateAccountLayout,
    props: true,
    meta: {
      secure:false,
    },
    
    children: [
      {
        path: '/register',
        name: 'Index',
        component: Index
      },
      {
        path: '/login',
        name: 'LoginPage',
        component: LoginPage
      },
      {
        path: '/escort',
        name: 'SignupPage2',
        component: SignupPage2
      },
      {
        path: '/guest',
        name: 'GuestSignupPage',
        component: GuestSignupPage
      },
    ]
  },

  
  {
    path: '/',
    component: DashboardPage,
    props: true,
    meta: {
      secure:false,
    },
    children: [
      {
        path: '/',
        name: 'MainPage',
        component: MainPage,
        meta: {
          secure:true,
        }
      },
      
      {
        path: '/models',
        name: 'Models',
        component: Models, 
        // Add meta fields for SEO
        meta: {
          title: 'Search Models - Dayruns'
        }
      },
      {
        path: '/vip-lounge',
        name: 'LoungePage',
        beforeEnter : beforeRouteEnter,
        component: LoungePage,
        meta: { secure:true, requiresVip: true }
      },
      {
        path: '/rooms',
        name: 'RoomsPage',
        component: RoomsPage
      },
      {
        path: '/faq',
        name: 'FaqPage',
        component: FaqPage
      },
      {
        path: '/videos',
        name: 'VideoPage',
        //beforeEnter : beforeRouteEnter,
        component: VideoPage,
        meta: {
          secure:true,
        }
      },
      {
        path: '/admin',
        name: 'AdminPage',
        beforeEnter : beforeRouteEnter,
        component: AdminPage,
        meta: {
          secure:true,
        }
      },
      {
        path: '/chats',
        name: 'UserChatHangout',
        beforeEnter : beforeRouteEnter,
        component: UserChatHangout,
        meta: {
          secure:true,
        }
      },
      {
        path: '/wallet-topup',
        name: 'WalletTopupPage',
        beforeEnter : beforeRouteEnter,
        component: WalletTopupPage,
        meta: {
          secure:true,
        }
      },

      {
        path: '/profile/:escortid/:username',
        name: 'ProfilePage',
        beforeEnter : beforeRouteEnter,
        component: ProfilePage,
        meta: {
          secure:true,
        }
      },
      {
        path: '/add-bank/:escortid/:username',
        name: 'BankPage',
        beforeEnter : beforeRouteEnter,
        component: BankPage,
        meta: {
          secure:true,
        }
      },
      {
        path: '/update-profile/:escortid/:username',
        name: 'EditProfilePage',
        beforeEnter : beforeRouteEnter,
        component: EditProfilePage,
        meta: {
          secure:true,
        }
      },
      {
        path: '/add-my-bank/:escortid/:username',
        name: 'AddBank',
        beforeEnter : beforeRouteEnter,
        component: AddBank,
        meta: {
          secure:true,
        }
      },
      {
        path: '/my-wallet/:escortid/:username',
        name: 'WalletPage',
        beforeEnter: beforeRouteEnter,
        component: WalletPage,
        meta: {
          secure:true,
        }
      },
      {
        path: '/escort-profile/:escortid/:username',
        name: 'EscortDetailPage',
        component: EscortDetailPage,
      },
      {
        path: '/escort-tour/:escortid/:username',
        name: 'TourDetailPage',
        component: TourDetailPage,
        meta: {
          secure:true,
        }
      },
      {
        path: '/video-detail/:escortid/:username',
        name: 'VideoDetailsPage',
        component: VideoDetailsPage,
        meta: {
          secure:true,
        }
      },
      {
        path: '/chat/:escortid/:username',
        name: 'UserChat',
        //beforeEnter : beforeRouteEnter,
        component: UserChat,
        meta: {
          secure:true,
        }
      },
      {
        path: '/group-chat',
        name: 'GroupChat',
        //beforeEnter : beforeRouteEnter,
        component: GroupChat,
        meta: {
          secure:true,
        }
      },
      {
        path: '/boost-profile/:escortid/:username',
        name: 'BoostPlansPage',
        //beforeEnter : beforeRouteEnter,
        component: BoostPlansPage,
        meta: {
          secure:true,
        }
      },
      {
        path: '/activate-profile/:escortid/:username/',
        name: 'ActivatePlan',
        //beforeEnter : beforeRouteEnter,
        component: ActivatePlan,
        meta: {
          secure:true,
        }
      },
      {
        path: '/guest-profile/:clientid/:username',
        name: 'ClientPage',
        //beforeEnter : beforeRouteEnter,
        component: ClientPage,
        meta: {
          secure:true,
        }
      },
     
    ]
  },

  {
    path: '/rooms',
    name: 'RoomsLayout',
    component: RoomsLayout,
    props: true,
    meta: {
      secure:false,
    },
    
    children: [
      
    ]
  },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// ==============================
// GLOBAL ROUTE GUARD
// ==============================
router.beforeEach((to, from, next) => {
  try {
    const token = localStorage.getItem("wertyuiojhdfghhdrtfyguh");

    // ------------------------------
    // Public pages (no auth needed)
    // ------------------------------

    // Public dynamic pages
    const isEscortProfile = to.path.startsWith("/escort-profile/");

    const publicPages = ["/", "/vip-lounge", "/models", "/rooms", "/videos", "/faq", "/login", "/register", "/guest", "/escort"];

    // ------------------------------
    // No token → allow public only
    // ------------------------------
   if (!token) {
      if (publicPages.includes(to.path) || isEscortProfile) {
        return next();
      }
      return next("/");
    }

    const jwtPayload = parseJwt(token);

    // ------------------------------
    // Token expired → logout
    // ------------------------------
    if (!jwtPayload || jwtPayload.exp < Date.now() / 1000) {
      console.warn("JWT expired → logging out");

      // Clear local storage
      localStorage.removeItem("userid");
      localStorage.removeItem("role");
      localStorage.removeItem("email");
      localStorage.removeItem("isChat");
      localStorage.removeItem("wertyuiojhdfghhdrtfyguh");
      localStorage.removeItem("user_balance");
      localStorage.removeItem("name");

      // Reset Vuex balance
      store.commit("SET_WALLET_BALANCE", 0);

      return next("/"); // redirect to login
    }

    // ------------------------------
    // Prevent logged-in users from
    // visiting login/register
    // ------------------------------
    if (to.path === "/login" || to.path === "/register") {
      return next("/"); // or dashboard
    }

    return next();

  } catch (err) {
    console.error("Auth guard error:", err);

    // Clear local storage
    localStorage.removeItem("userid");
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    localStorage.removeItem("isChat");
    localStorage.removeItem("wertyuiojhdfghhdrtfyguh");
    localStorage.removeItem("user_balance");
    localStorage.removeItem("name");

    // Reset Vuex balance
    store.commit("SET_WALLET_BALANCE", 0);

    next("/");
  }
});


export default router
